import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import {
  openErrorOrWarningDialog,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  EditProductTableSuccess,
} from "../../Redux/Actions/InputData";
import {
  API_BASE_URL,
  NEW_BULK_EDIT_NUTRITION_OEE_CPT_TABLE_API,
  NUTRITION_DOWNLOAD_OEE_CPT_TABLE_API,
  NUTRITION_VIEW_OEE_CPT_TABLE_API,
} from "../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import OEEAndCPTTables from "./OEEAndCPTTables";
import btnDownloadIcon from "./../../Assests/download.svg";
import { postRequest, putRequest } from "../../Services/AxiosConfiguration";
import axios from "axios";
import FileSaver from "file-saver";
import * as actions from "../../Redux/Actions/index";
import ErrorOrWarningDialog from "../../Components/Modals/ErrorOrWarningDialog";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import btnSaveIcon from "./../../Assests/Save-btn.svg";

import AddRowButton from "../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../Components/Common/ConfirmationDialog";

function PackagingOEEAndCPTInputs(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [selectRMPMDescription, setSelectRMPMDescription] = useState("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [descriptionOptions, setDescriptionOptions] = useState<any>([]);
  // const [filterRequest, setFilterRequest] = React.useState([]);
  // const [filterRequest, setFilterRequest] = React.useState([{"key": "Factory_Name", "value": ""}, {"key": "RM_PM_Description", "value": ""}]);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "line", value: "" },
    { key: "basepack", value: "" },
    { key: "time_period", value: "" },
  ]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const {
    isErrorDialog,
    errorMessage,
    isErrorOrWarningDialog,
    errorOrWarningMessage,
  } = useSelector((state: any) => state.InputDataReducers);

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  var fact = 0;
  var base = 0;
  var time = 0;

  /**Redux state */
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );
  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  useEffect(() => {
    if (
      selectedUsecaseId === undefined ||
      selectedCategoryId === undefined ||
      selectedFolderId === undefined ||
      selectedScenarioId === undefined
    ) {
      //setPageIsLoaded(true);
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase, category and folder.",
        ),
      );
    } else {
      //setPageIsLoaded(false);
    }
    // callTableGridApi();
  }, []);

  // useEffect(() => {
  //   callTableGridApi();
  // }, []);
  useEffect(() => {
    callTableGridApi();
    getfiltersApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);

  const callTableGridApi = (resetfilter?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        scenarioId === 0
          ? "tblNutritionPackagingOEEandCPT"
          : "tblScenario_NutritionPackagingOEEandCPT",
      time_period: timePeriodValues,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: resetfilter ? resetfilter : filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + NUTRITION_VIEW_OEE_CPT_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);

          if (fact === 0) {
            setFactoryOptions(actions.loadFactoryOptions(response.data));
          }

          setLineOptions(actions.loadLineOptions(response.data));

          if (base === 0)
            setBasepackOptions(actions.loadBasePackOptions(response.data));

          if (time === 0)
            setTimePeriodOptions(loadTimePeriodOptions(response.data));

          // loadFactoryOptions(response.data);
          // loadTimePeriodOptions(response.data);
          // loadLineOptions(response.data);
          // loadBasePackOptions(response.data);
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };
  const loadFactoryOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.factory_Name === item.factory;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({ id: item.id, factory_Name: item.factory });
      }
    });
    return factoryOptions;
  };

  const loadLineOptions = (data: any) => {
    const lineOptions: any = [];
    data.map((item: any) => {
      const filteredItem = lineOptions.find((obj: any) => {
        return obj.line === item.line;
      });
      if (filteredItem === undefined || filteredItem == null) {
        lineOptions.push({ id: item.id, line: item.line });
      }
    });
    setLineOptions(lineOptions);
  };

  const loadBasePackOptions = (data: any) => {
    const basePackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = basePackOptions.find((obj: any) => {
        return obj.basepack === item.basepack;
      });
      if (filteredItem === undefined || filteredItem == null) {
        basePackOptions.push({ id: item.id, basepack: item.basepack });
      }
    });
    setBasepackOptions(basePackOptions);
  };

  const loadTimePeriodOptions = (data: any) => {
    const timePeriodPackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodPackOptions.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodPackOptions.push({
          id: item.id,
          time_Period: item.time_Period,
        });
      }
    });
    return timePeriodPackOptions;
    // setTimePeriodOptions(timePeriodPackOptions);
  };

  const getfiltersApi = () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        scenarioId === 0
          ? "tblNutritionPackagingOEEandCPT"
          : "tblScenario_NutritionPackagingOEEandCPT",
      time_period: timePeriodValues,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + NUTRITION_VIEW_OEE_CPT_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          //setFactoryOptions(response.data.factory_NameFilter);
          setFactoryOptions(loadFactoryOptions(response.data));
          setDescriptionOptions(response.data.rM_PM_DescriptionFilter);
        }
      })
      .catch((error) => {
        dispatch(ViewProductTableError(error));
      });
  };

  const handleChangeSelectFactory = (event: any) => {
    fact = 1;
    base = 0;
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    setSelectBasepack("");
    setSelectTimePeriod("");
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    filterRequest[0].value = value;
    callTableGridApi();
  };

  // const handleChangeSelectDescription = (event: any) => {
  //   const { target: { value } } = event;
  //   setSelectRMPMDescription(value);
  //   callTableGridApi();
  // };

  const handleChangeSelectLine = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectLine(value);
    filterRequest[1].value = value;
    callTableGridApi();
  };

  const handleChangeSelectBasepack = (event: any) => {
    fact = 1;
    base = 1;
    time = 0;
    filterRequest[3].value = "";
    setSelectTimePeriod("");
    const {
      target: { value },
    } = event;
    setSelectBasepack(value);
    filterRequest[2].value = value;
    callTableGridApi();
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectTimePeriod(value);
    filterRequest[3].value = value;
    callTableGridApi();
    time = 1;
    base = 1;
    fact = 1;
  };

  const handleRestoreClicked = (e: any) => {
    setSelectFactory("");
    setSelectBasepack("");
    setSelectRMPMDescription("");
    setSelectTimePeriod("");
    filterRequest.filter((element) => element.value != "");
    setFilterRequest([
      { key: "factory", value: "" },
      { key: "line", value: "" },
      { key: "basepack", value: "" },
      { key: "time_period", value: "" },
    ]);
    callTableGridApi([]);
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "filter": filterList };

    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        scenarioId === 0
          ? "tblNutritionPackagingOEEandCPT"
          : "tblScenario_NutritionPackagingOEEandCPT",
      time_period: timePeriodValues,
      filter: filterList,
    };
    const urls = API_BASE_URL + NUTRITION_DOWNLOAD_OEE_CPT_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "factory_Code",
      "factory",
      "format",
      "cascade",
      "line",
      "pack",
      "basepack_Code",
      "basepack",
      "product",
      "time_Period",
      "processing_Time",
      "oee",
      "conversion_Cost_per_Tonne",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        factory_Code: "",
        factory: "",
        format: "",
        cascade: "",
        line: "",
        pack: "",
        basepack_Code: "",
        basepack: "",
        product: "",
        time_Period: "",
        processing_Time: "",
        oee: 0,
        conversion_Cost_per_Tonne: 0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        rest.usecaseId = selectedUsecaseId;
        rest.category_Id = selectedCategoryId;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls =
      API_BASE_URL +
      NEW_BULK_EDIT_NUTRITION_OEE_CPT_TABLE_API +
      `?ScenarioId=${selectedScenarioId}`;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    putRequest(urls, transformedRows, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited packaging OEE&CPT table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {isErrorOrWarningDialog && (
        // eslint-disable-next-line react/jsx-no-undef
        <ErrorOrWarningDialog
          isErrorOrWarningDialog={isErrorOrWarningDialog}
          errorOrWarningMessage={errorOrWarningMessage}
        />
      )}
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3> Packaging OEE & CPT</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Factory</em>
                  </MenuItem>
                  {factoryOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.factory_Name}>
                        {d.factory_Name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <InputLabel>Line</InputLabel>
                <Select
                  id="simple-select-3"
                  value={selectLine}
                  placeholder="Select Line"
                  onChange={handleChangeSelectLine}
                  renderValue={(selectLine: any) => selectLine}
                  className="select-short-term">
                  {lineOptions?.map((d: any) => {
                    return (<MenuItem key={d} value={d.line}>{d.line}</MenuItem>)
                  })}
                </Select>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Basepack</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectBasepack}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectBasepack}
                  // renderValue={(selectBasepack: any) => selectBasepack}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Basepack</em>
                  </MenuItem>
                  {basepackOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.basepack}>
                        {d.basepack}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>TimePeriod</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTimePeriod}
                  placeholder="Select TimePeriod"
                  onChange={handleChangeSelectTimePeriod}
                  // renderValue={(selectTimeperiod: any) => selectTimeperiod}
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>TimePeriod</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={handleDownload}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <OEEAndCPTTables
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          ref={childRef}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default PackagingOEEAndCPTInputs;
